import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import TableRow from './TableRow';
import t from './i18n';
import './style.scss';

@withRouter @observer
export default class Table extends React.Component {

	static propTypes = {
		records: PropTypes.any.isRequired,

		/*
		 * Массив вида [ property, dir ].
		 * property - свойство, по которому отсортированы записи
		 * dir - направление сортировки, возможнные значения: 'asc' и 'desc'.
		 * Указывает таблице как остортированы записи.
		 * Нужен для формирования заголовков в виде ссылок, меняющих сортировку.
		 * Если не задан - заголовки будут обычным текстом.
		 */
		order: PropTypes.any,

		/*
		 * Функция, будет вызвана при клике на заголовок.
		 * В аргументе будет передано свойство (property).
		 * Будет вызываться только для полей с заданным property, и без relation.
		 */
		onSort: PropTypes.func,

		getRef: PropTypes.func,

		className: PropTypes.string,

		/*
		 * Путь, по которому будет переход вида {rootPath}/{path}/{id}
		 * если не задан, переход будет по plural модели {rootPath}/{plural}/{id}
		 */
        path: PropTypes.string,

		/*
		 * Корневой путь, по умолчанию '/'
		 */
        rootPath: PropTypes.string,

		/*
		 * Функция, если задана, будет вызвана при клике на строку таблицы.
		 * В аргументах будут переданы:
		 * record - запись в строке
		 * row = номер строки, начиная с 0
		 */
		onRowClick: PropTypes.func,
		clickable: PropTypes.bool,

		/*
		 * Функция, в аргументах будут переданы (record, row) - запись и номер строки.
		 * Если вернёт true - строка таблицы будет подсвечена.
		 */
		hilightRow: PropTypes.func,

		/*
		 * Функция, в аргументах будут переданы (record, row) - запись и номер строки.
		 * Должна возвращать название класса, который будет присвоен строке.
		 */
		rowClassName: PropTypes.func,

        debug: PropTypes.bool,
        keyName: PropTypes.string,
		noRecordsMsg: PropTypes.any,
		wrapper: PropTypes.any,
	};

	static defaultProps = {
        rootPath: '/',
		debug: false,
		noRecordsMsg: t('Table.noRecords'),
		clickable: true,
		wrapper: React.Fragment,
	};

	constructor(props) {
		super(props);
	}

	onMount = el => {
		if (this.props.getRef) this.props.getRef(el);
	};

	sortWithProperty = (e, property) => {
		e.preventDefault();
		if (this.props.onSort) this.props.onSort(property);
	};

	sortWithFunc = (e, sortFunc) => {
		e.preventDefault();
		sortFunc();
	};

	getLabel = props => {
		if (props.label) return props.label;
		if (this.props.records.length > 0) {
			const record = this.props.records[0];
			const modelInfo = record.MODEL.INFO;
			// console.log('modelInfo', modelInfo);
			if (props.relation && modelInfo.relations[props.relation]) {
				return modelInfo.relations[props.relation].description || '';
			}
			if (props.property && modelInfo.properties[props.property]) {
				return modelInfo.properties[props.property].description || '';
			}
		}
		return '';
	};

	render() {
		const { children, records, debug, path, rootPath, className, onRowClick, hilightRow, keyName, clickable, rowClassName } = this.props;

		if (!records) return 'no records';
		if (records.length === undefined) return 'records is not an array';

		const headers = [];
		let i = 0;

		React.Children.forEach(children, child => {
			if (!child) return;
			let label = this.getLabel(child.props);
			let width = undefined;
			let className = undefined;
			if (child && typeof child === 'object' && child.props) {
				if (this.props.order) {
					if (child.props.sortFunc) {
						label = <a href="#" onClick={e => this.sortWithFunc(e, child.props.sortFunc)}>{label}</a>
					}
					else if (child.props.property && !child.props.relation) {
						label = <a href="#" onClick={e => this.sortWithProperty(e, child.props.property)}>{label}</a>
					}
					if (this.props.order[0] === child.props.property) {
						label = <>
							{label}&nbsp;
							{this.props.order[1] === 'asc' ? <>&darr;</> : <>&uarr;</>}
						</>;
					}
				}
				width = child.props.width ? child.props.width + child.props.padding * 2 : undefined;
				className = child.props.className || undefined;
			}
			headers.push(<th key={i++} width={width} className={className}>{label}</th>);
		});

		const key = keyName || (records && records.length > 0 ? records[0].MODEL.INFO.name : 'unknown');

		const rows = records && records.map((record, row) => {
			const hilighted = hilightRow && hilightRow(record, row);
			// const _path = this.props.match ? this.props.match.url : path;
			// console.log('path', path, _path, this.props.match);
			const props = { record, row, path, rootPath, debug, onRowClick, hilighted, clickable, rowClassName };
			return <TableRow {...props} key={`${key}-${record.id}`}>
				{children}
			</TableRow>;
		});

		const _className = 'ui-table ' + (className || '');

		const Wrapper = this.props.wrapper;

		return <Wrapper>
			{records && records.length > 0 ?
				<table className={_className} ref={this.onMount}>
					<thead><tr>{headers}</tr></thead>
					<tbody>{rows}</tbody>
				</table>
			    :
				<div>{this.props.noRecordsMsg}</div>
			}
		</Wrapper>;
	}

}
